import CardsHelper from '../../../Utility/CardsHelper';
import { IGameState } from '../../Game/IGameState';
import { setCardState } from '../CardStateHelper';
import BaseModifierBehavior from './BaseModifierBehavior';

export default class LoweringModifierBehavior extends BaseModifierBehavior {
    public onCardMatched(state: IGameState, matchedCardID: string) {
        if (!this.validateUpdate(state)) return state;

        if (matchedCardID === this.cardID) return state;

        const value = state.levelState.cardsState.cards[this.cardID].value;
        const newValue = CardsHelper.instance.draw(value - 1);

        state = setCardState(state, {
            ...state.levelState.cardsState.cards[this.cardID],
            value: newValue,
        });

        return state;
    }
}
